import React, { useEffect, useState } from "react";
import {
  capitalizeFirstLetter,
  getInputDateFromTime,
  string_to_slug,
} from "../../store/utility";

const ExpiryCard = (props) => {
  const [expiry, setExpiry] = useState("");

  const product = props.product;

  useEffect(() => {
    if (product) {
      setExpiry(product.expiry);
    }
  }, [product]);

  const handleChange = (e) => {
    let timestamp = new Date(e.target.value).getTime();
    setExpiry(timestamp);
  };
  const getAttributes = () => {
    let attrs = [];
    if (product.attributes) {
      let attributes = product.attributes;
      for (let attrkey in attributes) {
        attrs.push(
          <div>
            <strong>
              {capitalizeFirstLetter(attributes[attrkey].attribute)}
            </strong>
            : {attributes[attrkey].name}
          </div>
        );
      }
      return attrs;
    } else {
      return null;
    }
  };
  return (
    <>
      <div className="d-flex align-items-baseline border border-light border-3 shadow-sm rounded mt-2">
        <div style={{ width: "80px", height: "80px" }} className="m-2">
          <img className="w-100 h-100" src={product.previewImages[0]} />
        </div>

        <div className="m-2 flex-grow-1">
          <a
            href={`/product/${string_to_slug(product.productTitle)}/${
              product.id
            }`}
            className="cursor-pointer"
            target="_blank"
          >
            <h6>{product.productTitle}</h6>
          </a>
          {product.variantId && getAttributes()}
        </div>
        <div className="m-2 ">
          <input
            type="date"
            required
            className="form-control form-control-sm text-center"
            value={getInputDateFromTime(expiry)}
            onChange={handleChange}
          />
        </div>
        <div className="m-2 ">
          <button
            className="btn btn-sm btn-primary"
            onClick={() => props.updateExpiry(expiry)}
            disabled={props.updateBtnLoading}
          >
            {/* {props.updateBtnLoading?"Updating":"Update"} */}
            Update
          </button>
        </div>
      </div>
    </>
  );
};

export default ExpiryCard;
